import { render, staticRenderFns } from "./menuDetail.vue?vue&type=template&id=50dbf2eb&"
import script from "./menuDetail.vue?vue&type=script&lang=js&"
export * from "./menuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports